import useTranslation from 'next-translate/useTranslation';
import { memo } from 'react';

import {
  Box,
  CardVideoTutorial,
  Container,
  EditorContent,
  Grid,
  LinkGoBackBase,
  Typography,
} from '@core/component';
import { Translate } from '@core/constant';
import { useContextMediaQuery } from '@core/context';
import { EActionAttribute, EEditor, ERouting, ETypographyVariant, PageSSR } from '@core/type';
import { TutorialVideoBySlugEntity } from '@core/type/api';

export type ViewTutorialVideoProps = PageSSR<TutorialVideoBySlugEntity, unknown, unknown>;

const ViewTutorialVideoContainer = ({ name, content, suggestedVideos }: ViewTutorialVideoProps) => {
  const { isMobile } = useContextMediaQuery();

  const { t: tTutorialVideo } = useTranslation(Translate.page.TUTORIAL_VIDEO);

  return (
    <Box>
      <LinkGoBackBase redirection={ERouting.TUTORIAL_VIDEOS}>
        {tTutorialVideo('link.tutorialVideos')}
      </LinkGoBackBase>
      <Container maxWidth={'755px'} gutter={0}>
        <Typography
          variant={ETypographyVariant.H1}
          marginTop={'64px'}
          marginBottom={'40px'}
          textAlign={'center'}
        >
          {name}
        </Typography>

        <EditorContent content={content} type={EEditor.TUTORIAL} />
      </Container>
      {suggestedVideos.length > 0 && (
        <Box marginTop={isMobile ? '104px' : '144px'}>
          <Typography
            textAlign="center"
            marginBottom="40px"
            as={EActionAttribute.H2}
            variant={ETypographyVariant.H4}
          >
            {tTutorialVideo('suggestions.title')}
          </Typography>
          <Grid isContainer rowSpacing={48} columnSpacing={30}>
            {suggestedVideos.map(({ name, slug, image }) => (
              <Grid key={slug} sm={6} lg={4}>
                <CardVideoTutorial slug={slug} title={name} imageProps={image} />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export const ViewTutorialVideo = memo(ViewTutorialVideoContainer);
